export default __webpack_public_path__ + "static/media/oxigenoterapia_adultos.9bacdb24.pdf";